import React, { Component } from "react";
import { PropTypes } from "prop-types";
export class Step extends Component {
  constructor() {
    super();   
  }
 
  render() {
    const {
      text,
      icon,
      index,
      active,
      completed,
      first,
      isLast,
      href,
      onClick,
      width
    } = this.props;

     
    const stepContent = icon ? <img src={icon} alt={index + 1} /> : index + 1;

    return (
      <div style={{  width: `${width}%`,}} className={"step"}>
        <div className={"stepper-circle" + (completed ? " stepper-completed-circle" : "") + (active ? " stepper-active-circle" : "")}>
          {active || completed ? (
            <a href={href} onClick={onClick} className={"stepper-index"}>
              {stepContent}
            </a>
          ) : (
            <span className={"stepper-index"}>{stepContent}</span>
          )}
        </div>
        {active || completed ? (
          <a href={href} onClick={onClick} className={"stepper-title" + (completed ? " stepper-completed-title" : "") + (active ? " stepper-active-title" : "")}>
            {text}
          </a>
        ) : (
          <div className={"stepper-title" + (completed ? " stepper-completed-title" : "") + (active ? " stepper-active-title" : "")}>{text}</div>
        )}
        {!first && <div  className={"stepper-left-bar" + (active || completed ? " stepper-completed-bar" : "")}></div>}
        {!isLast && <div className={"stepper-right-bar" + (completed ? " stepper-completed-bar" : "")}></div>}
      </div>
    );
  }
}

Step.defaultProps = {
 
};

Step.propTypes = {
  text : PropTypes.string,   
  index :PropTypes.number,
  active : PropTypes.bool,
  completed : PropTypes.bool,
  first : PropTypes.bool,
  isLast : PropTypes.bool,
  href : PropTypes.string,
  onClick : PropTypes.func,
  width: PropTypes.number.isRequired,
};

export default function SLStepper({
  activeStep,
  steps,
  disabledSteps,   
  size,  
}) {
  return (
    <div className="stepper-root">
      <div className="stepper">
        {steps.map((step, index) => (
          <Step
            key={index}
            width={100 / steps.length}
            text={step.text}
            icon={step.icon}
            href={step.href}
            onClick={step.onClick}
            active={
              !(disabledSteps || []).includes(index) && index === activeStep
            }
            completed={
              !(disabledSteps || []).includes(index) && index < activeStep
            }
            first={index === 0}
            isLast={index === steps.length - 1}
            index={index}             
            size={size}             
          />
        ))}
      </div>
    </div>
  );
}

SLStepper.defaultProps = {
  activeStep: 0,
};

SLStepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array, 
  disabledSteps: PropTypes.array, 
  size: PropTypes.number,  
};



// WEBPACK FOOTER //
// ./src/components/editors/SLStepper.jsx